
import React, { useState, useContext, createContext, useRef, useEffect } from 'react'
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
	Label,
    Modal,
	ModalBody,
	ModalFooter,
    ModalHeader
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { SpinnerComponent } from 'react-element-spinner'
import dayjs from 'dayjs'

import { trigger } from '../../events/customEvents'
import AuctionsService from '../../services/AuctionsService'
import SiteService from '../../services/SiteService'
import { SessionContext } from '../../contexts/SessionProvider'

const AuctionNoteModal = ({ showAuctionNoteModal, auctionNote, setAuctionNote }) =>
{
    const { t } = useTranslation()
    const [modalIsBusy, setModalIsBusy] = useState(false)
    const sessionContext = useContext(SessionContext)
    const [noteSubmitted, setNoteSubmitted] = useState(false)

    const handleOnOpened = () =>
    {

    }

    const handleCancelModal = () =>
    {
        trigger('auctionNoteModalClosed', { noteAdded: false, reason: 'Cancelled' })
    }
	
	const handleAuctionNotePropertyChange = (e) =>
	{
		const { name, value} = e.target
		setAuctionNote((previousAuctionNote) =>
		{
			let currentAuctionNote = { ...previousAuctionNote }
			currentAuctionNote[name] = value
			if (name === 'note')
			{
				currentAuctionNote.validation[name] = !!(value && value.length > 0)
			}
			return currentAuctionNote
		})
	}
	
	const handlePublicCheckboxChange = (isPublic) =>
	{
		setAuctionNote((previousAuctionNote) =>
		{
			let currentAuctionNote = { ...previousAuctionNote }
			currentAuctionNote.public = !isPublic
			return currentAuctionNote
		})
	}
	
    const validNote = () =>
    {
        return auctionNote.validation.note
    }

    const handleSaveNote = () =>
    {
        setNoteSubmitted(true)
        if (validNote())
        {
            setModalIsBusy(true)
            AuctionsService
                .addAuctionNote(auctionNote, sessionContext.loginSession.user.userSession.sessionKey)
                .then(result =>
                {
                    setModalIsBusy(false)
                    sessionContext.updateSession(result.data.loginSession)

                    trigger('auctionNoteModalClosed', {noteAdded: true, reason: 'Added'})
                })
                .catch((error) =>
                {
                    setModalIsBusy(false)
                    SiteService.displayApiError(error)
                })
        }
    }

    return (
        <>
{/*            <Modal
                className="modal-dialog-centered"
                size="lg"
                fullscreen="md"
                isOpen={ showAuctionNoteModal }
                onOpened={ handleOnOpened }
            >
                <ModalHeader className="modal-banner">
                    <h3 className="modal-banner-title">{t('Auctions.Notes.Modal_Title')}</h3>
                    <button
                        aria-label="Close"
                        className="close modal-close-button"
                        type="button"
                        onClick={ handleCancelModal }
                    >
                        <span aria-hidden={true}>x</span>
                    </button>
                </ModalHeader>
                <SpinnerComponent
                    loading={ modalIsBusy }
                    position="centered"
                    color="#3578e5"
                    secondaryColor="#f3f3f3"
                    backgroundColor="#d3d3d3"
                    spinnerType="circle-dots"
                />
                <div className="modal-body p-0">
                    <Card className="bg-secondary border-0 mb-0">
                        <CardBody className="px-lg-5 py-lg-5">

                            <Col md="12" className="text-primary" >
                                <Form role="form">
                                    <FormGroup>
                                        <Input
                                            className="form-control-sm"
                                            type="text"
                                            name="counterBidAmount"
                                            placeholder={t('Modals.CounterMemberBid.Counter_Bid_Amount')}
                                            value={counterBid.counterBidAmount}
                                            onChange={handleCounterBidPropertyChange}
                                            valid={counterBidSubmitted && counterBid.validation.counterBidAmount}
                                            invalid={counterBidSubmitted && !counterBid.validation.counterBidAmount}
                                        />
                                        <Input
                                            type="textarea"
                                            name="note"
                                            value={ auctionNote.note }
                                            onChange={ handleAuctionNotePropertyChange }
                                            valid={ noteSubmitted && auctionNote.validation.note }
                                            invalid={ noteSubmitted && !auctionNote.validation.note }
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <input
                                            type="checkbox"
                                            name="public"
                                            checked={ auctionNote.public }
                                            onChange={ handleAuctionNotePropertyChange }
                                        />
                                        <label className="form-control-label" style={{ marginLeft: '3px' }}>{ t('Auctions.Notes.Public') }</label>
                                    </FormGroup>
                                    <div className="text-center">
                                        <Button
                                            className="no-padding"
                                            color="default"
                                            type="button"
                                            size="sm"
                                            onClick={() => handleCancelModal()}
                                        >
                                            { t('Modals.PlaceMemberBid.Cancel') }
                                        </Button>
                                        <Button
                                            className="no-padding"
                                            color="primary"
                                            type="button"
                                            size="sm"
                                            onClick={() => handleSaveNote()}
                                        >
                                            { t('Auctions.Notes.Save') }
                                        </Button>
                                    </div>
                                </Form>
                            </Col>

                        </CardBody>
                    </Card>
                </div>
            </Modal>*/}
			
			<Modal
				size="lg"
				isOpen={ showAuctionNoteModal }
				toggle={ () => handleCancelModal() }
				onOpened={ handleOnOpened }
			>
				<ModalHeader toggle={ () => handleCancelModal() } charCode="Y">
					<Label>Add Note</Label>
				</ModalHeader>
				<ModalBody>
					<Card className="border-0 mb-0">
						<CardBody>
							<Col md="12" className="text-primary" >
								<Form role="form">
									<FormGroup>
										<Input
											type="textarea"
											name="note"
											value={ auctionNote.note }
											onChange={ handleAuctionNotePropertyChange }
											valid={ noteSubmitted && auctionNote.validation.note }
											invalid={ noteSubmitted && !auctionNote.validation.note }
										/>
									</FormGroup>
									
									<FormGroup>
										<Input
											type="checkbox"
											name="public"
											checked={ auctionNote.public }
											onChange={ () => handlePublicCheckboxChange(auctionNote.public) }
										/>
										<Label style={{ marginLeft: '3px' }}>{ t('Auctions.Notes.Public') }</Label>
									</FormGroup>
									<div className="text-center">
										<Button
											color="secondary"
											type="button"
											size="sm"
											onClick={() => handleCancelModal()}
										>
											{ t('Modals.PlaceMemberBid.Cancel') }
										</Button>
										<Button
											color="primary"
											type="button"
											size="sm"
											onClick={() => handleSaveNote()}
											style={{ marginLeft: '10px' }}
										>
											{ t('Auctions.Notes.Save') }
										</Button>
									</div>
								</Form>
							</Col>
						</CardBody>
					</Card>
				</ModalBody>
				<ModalFooter></ModalFooter>
			</Modal>
        </>
    )
}

export default AuctionNoteModal
